import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../logo.png';

export const LandingFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="py-4 border-top border-secondary border-opacity-25" style={{ backgroundColor: '#f8fafc' }}>
      <div className="container">
        <div className="row align-items-center g-3">
          <div className="col-12 col-md-6 text-center text-md-start">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-2 mb-2">
              <img src={logo} alt="Bryemma Logo" style={{ height: '28px', width: 'auto' }} />
              <span className="fw-extrabold text-dark h5 mb-0">
                Bry<span style={{ color: 'var(--bry-accent, #0EABB0)' }}>emma</span>
              </span>
            </div>
            <p className="text-secondary small mb-0">
              © {new Date().getFullYear()} Bryemma Inc. Moviendo a El Tigre, Anzoátegui con seguridad y tecnología.
            </p>
          </div>

          <div className="col-12 col-md-6 text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-3 small">
              <button className="btn btn-link text-secondary text-decoration-none p-0" onClick={() => navigate('/terminos')}>
                Términos
              </button>
              <span className="text-secondary">•</span>
              <button className="btn btn-link text-secondary text-decoration-none p-0" onClick={() => navigate('/privacidad')}>
                Privacidad
              </button>
              <span className="text-secondary">•</span>
              <button className="btn btn-link text-secondary text-decoration-none p-0" onClick={() => navigate('/soporte')}>
                Soporte
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
